import styled from 'styled-components';
import { device, size } from '../../styles/devices';
import { SIZING, COLORS } from '../../styles/variables';

export const Container = styled.div`
  background-color: ${COLORS.audiGrayFive};
  padding: 16px 18px 20px;
  font-family: 'Audi Type';
  @media ${device.tablet} {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 60px;
  }
  @media ${device.laptop} {
    padding: 90px 90px 120px;
  }
`;

export const InnerContainer = styled.div`
  .ReactCollapse--collapse {
    transition: height 300ms;
  }
  margin: 0 auto 36px;
  @media ${device.tablet} {
    width: calc(100% - 60px);
    margin-bottom: 68px;
  }
`;

export const Row = styled.div`
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: fit-content;
  max-width: 871px;
  margin: 0 auto;
  line-height: 21px;
  font-size: 16px;
  font-weight: 700;
  padding-top: 20px;
  span {
    white-space: nowrap;
  }
  @media (max-width: ${size.laptop}) {
    &:first-child {
      border-top: none;
    }
  }
`;

export const Price = styled.p`
  white-space: nowrap;
`;

export const PrimaryRow = styled(Row)`
  min-height: 83px;
`;

export const SecondaryRow = styled(Row)`
  padding-left: 14px;
  @media ${device.tablet} {
    padding-left: 36px;
    padding-right: 24px;
  }
  min-height: 48px;
  align-items: flex-end;
`;

export const TotalKey = styled.p`
  margin-right: 20px;
  @media ${device.tablet} {
    font-size: 18px;
  }
`;

export const TotalValue = styled.div`
  font-size: 18px;
  white-space: nowrap;
`;

export const LegalCta = styled.div`
  font-size: 11px;
  cursor: pointer;
  line-height: 20px;
  font-weight: 600;
  font-family: 'Audi Type';
`;

export const CtaContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media ${device.tablet} {
    width: calc(100% - 60px);
    margin: 0 auto;
    max-width: 871px;
  }
  @media ${device.laptop} {
    flex-direction: row;
    justify-content: flex-end;
  }
`;

export const Cta = styled.a`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  height: 52px;
  width: 100%;
  border: 1px solid ${COLORS.black};
  font-size: 16px;
  @media ${device.tablet} {
    margin-left: 6px;
    padding: 18px;
  }
  @media ${device.laptop} {
    width: 266px;
  }
`;

export const PrimaryCta = styled(Cta)`
  background-color: ${COLORS.black};
  color: ${COLORS.white};
  order: 0;
  @media ${device.laptop} {
    width: 266px;
    order: 1;
  }
`;

export const SecondaryCta = styled(Cta)`
  background-color: transparent;
  color: ${COLORS.black};
  order: 1;
  @media ${device.laptop} {
    width: 266px;
    order: 0;
  }
`;

export const DealerListPrice = styled.div`
  display: block;
  height: fit-content;
  min-height: 83px;
  flex-grow: 1;
  padding-bottom: 12px;
  background-color: ${COLORS.grey80};
  border-bottom: 2px solid ${COLORS.black};
  @media ${device.tablet} {
    background-color: transparent;
    padding-bottom: 0;
    border-bottom: unset;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  margin-right: 8px;
  width: 100%;
  @media ${device.tablet} {
    min-height: 82px;
  }
`;

export const DealerName = styled.p`
  font-size: 13px;
  font-weight: normal;
  color: ${COLORS.white};
  margin-top: 4px;
  padding-left: 14px;
  @media ${device.tablet} {
    padding-left: unset;
  }
`;

export const TotalKeyContainer = styled.div`
  background-color: ${COLORS.grey80};
  color: ${COLORS.white};
  padding-left: 14px;
  padding-top: 14px;
  border-top: 2px solid ${COLORS.black};
  @media ${device.tablet} {
    margin-right: 8px;
    width: 100%;
    max-width: 614px;
    padding-left: 36px;
    border-bottom: 2px solid ${COLORS.black};
    padding-bottom: 14px;
  }
`;

export const TotalValueContainer = styled.div`
  background-color: ${COLORS.grey80};
  color: ${COLORS.white};
  padding-right: 14px;
  padding-top: 14px;
  flex-grow: 1;
  text-align: right;
  border-top: 2px solid ${COLORS.black};
  p:first-of-type {
    margin-right: 0;
  }
  @media ${device.tablet} {
    padding-left: 36px;
    padding-right: 24px;
    border-bottom: 2px solid ${COLORS.black};
    padding-bottom: 14px;
  }
`;

export const CloseModalButton = styled.button`
  border: none;
  background-color: transparent;
`;

export const LegalCtaContainer = styled.button`
  display: inline-block;
  height: 100%;
  vertical-align: super;
  border: none;
  background-color: inherit;
  color: ${COLORS.white};
  padding: unset;
  border-bottom: 1px solid ${COLORS.white};
  margin-left: ${SIZING.unit(0.75)};
`;
